import { UseQueryOptions } from 'react-query';
import { useCustomQuery } from '../../../../../hooks/query';

import {
  getSpecialConsiderationSubjectDetails,
  getDraftSavedDateTime,
  getTypesAndReasons,
  getReviewByUuid,
  getSCAcknowledgement,
  getSCSummary,
} from '../api-services/api';
import {
  SpecialConsiderationSubjectListingResponse,
  DraftSavedDateTimeResponse,
  TypesAndReasonsResponse,
  SpecialConsiderationReviewResponse,
  SpecialConsiderationSummaryResponse,
} from '../../model';
import {
  DRAFT_SAVED_DATE_TIME,
  GET_REVIEW_BY_UUID,
  GET_SC_ACKNOWLEDGEMENT_REQUEST,
  GET_SPECIAL_CONSIDERATION_SUMMARY,
} from './keys';
import {
  GET_SPECIAL_CONSIDERATION_SUBJECT_DETAILS,
  GET_TYPES_AND_REASONS,
} from '../api-services/routes';
import { ServiceError } from '../../../../../hooks/error';

/** to get special consideration subject listing
 * */
export const useGetSpecialConsiderationSubjectDetails = (requestUuid: string) =>
  useCustomQuery<SpecialConsiderationSubjectListingResponse[]>(
    [GET_SPECIAL_CONSIDERATION_SUBJECT_DETAILS, requestUuid],
    () => getSpecialConsiderationSubjectDetails(requestUuid).then((response) => response.data)
  );

export const useDraftSavedDateTime = (
  uuid: string,
  queryOptions?: UseQueryOptions<DraftSavedDateTimeResponse, ServiceError> | undefined
) =>
  useCustomQuery<DraftSavedDateTimeResponse>(
    [DRAFT_SAVED_DATE_TIME, uuid],
    () => getDraftSavedDateTime(uuid).then((res) => res.data),
    queryOptions,
    false,
    false
  );

export const useGetTypesAndReasons = () =>
  useCustomQuery<TypesAndReasonsResponse>([GET_TYPES_AND_REASONS], () =>
    getTypesAndReasons().then((response) => response.data)
  );

export const useGetSpecialConsiderationReview = (uuid: string) =>
  useCustomQuery<SpecialConsiderationReviewResponse>(GET_REVIEW_BY_UUID, () =>
    getReviewByUuid(uuid).then((res) => res.data)
  );

export const useGetSCAcknowledgement = (uuid: string) =>
  useCustomQuery(GET_SC_ACKNOWLEDGEMENT_REQUEST, () =>
    getSCAcknowledgement(uuid).then((res) => res.data)
  );

export const useGetSCSummary = (uuid: string) =>
  useCustomQuery<SpecialConsiderationSummaryResponse>(GET_SPECIAL_CONSIDERATION_SUMMARY, () =>
    getSCSummary(uuid).then((res) => res.data)
  );
